// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div#main-layout[data-v-7b1574e3]{background:#eee;height:100%}a#home-link[data-v-7b1574e3],a.v-btn[data-v-7b1574e3]{text-decoration:none}div#flex-row[data-v-7b1574e3]{display:flex;flex-direction:row;padding-top:30px;padding-bottom:10px}#main-content[data-v-7b1574e3]{display:flex;flex-direction:column;background-color:#fff;margin-right:0;margin-left:0;flex-grow:1;padding:30px 0 30px 0}", ""]);
// Exports
module.exports = exports;
